import React from "react";
// import { connect } from "react-redux";
// import // toggleSetting
// // handleSettings
// "../../../redux/actions/postActions";
import { Switch, Slider } from "./ToggleSwitchStyled";

export const ToggleSwitch = ({ isOn }) => {
  return (
    <Switch>
      <input checked={isOn} type="checkbox" onChange={() => {}} />
      <Slider className="slider" />
    </Switch>
  );
};
export default ToggleSwitch;
